import { useCallback, useEffect, useState } from 'react'
import { getUser } from 'services/auth.service'

// Its own key per user: logout() clears `lcost_user`, and the guide must stay
// finished after signing out. Per browser, so another device may show it again.
const storageKey = () => `lcost_guide_done_${getUser()?.userId || 'anonymous'}`

const isDone = () => {
  try { return localStorage.getItem(storageKey()) === '1' } catch { return false }
}

const markDone = () => {
  try { localStorage.setItem(storageKey(), '1') } catch { /* ignore */ }
}

// First-shipment guide. Only "finished" is stored: the progress comes from the
// shipment itself. The first successful calculation finishes it, but the panel
// stays up so the user sees the final step; a shipment that was already
// calculated when opened (existing users) never shows it.
const useShipmentGuide = (calculated) => {
  const [hidden, setHidden] = useState(() => calculated || isDone())

  useEffect(() => { if (calculated) markDone() }, [calculated])

  const dismiss = useCallback(() => {
    markDone()
    setHidden(true)
  }, [])

  return { visible: !hidden, dismiss }
}

export default useShipmentGuide
